<template>
  <div id="order">
    <MyProgress :indexVal="info.status" v-if="info.status!=5"/>
    <OrderStreamer :type="info.status"/>
    <ServiceSpecialist
        :orderNum="''+info.order_no"
        :staffName="info.staff_name"
        :workCode="info.work_code"
        :staffPhone="info.phone"
    />
    <BasicsInfo
        :name="info.name"
        :applyTime="info.createtime"
        :phone="info.tel"
        :getCarTime="info.get_car_date"
        :addr="info.address"
    />
<!--    <VehicleInfo-->
<!--        :carNum="info.car_number"-->
<!--        :VIN="info.identification"-->
<!--        :engineNum="info.engine_number"-->
<!--        :recordDate="info.register_date"-->
<!--        :operate="info.is_operated"-->
<!--    />-->
    <!-- 按钮 -->
    <div id="button">
      <transition name="button-anim" mode="out-in">
        <!-- 取消预约 -->
        <div class="cancel" v-if="info.status===1" key="cancel">
          <van-button
              class="cancel-button"
              @click="cancel"
              color="#fc3d38"
              :loading="isLoading"
          >取消预约</van-button>
        </div >
        <!-- 重新预约 -->
        <div class="cancel" v-if="info.status===5" key="repetition">
          <van-button
              class="cancel-button"
              color="#2794eb"
              :loading="isLoading"
              @click="toReserve"
          >重新预约</van-button>
        </div>
      </transition>
    </div>
    <!-- 客服 -->
    <ServiceTel height="13.2vw"/>
    <!-- 付款 -->
    <div id="pay" v-if="info.status===3">
      <div style="height: 13.067vw;"></div>
      <div class="pay">
        <p>
          <span style="font-size: 3.733vw;color: #303133;">实付&nbsp;</span>
          <span style="font-size: 3.733vw;color: #2794eb;">￥</span>
          <span style="font-size: 5.333vw;color: #2794eb;">{{'300'}}</span>
        </p>
        <van-button
            class="pay-button"
            color="#2794eb"
            :loading="isLoading"
            @click="payOrder(info.order_no)"
        >确认付款</van-button>
      </div>
    </div>
  </div>
</template>

<script>
  import OrderStreamer from '../widget/orderStreamer'
  import MyProgress from '../widget/progress'
  import ServiceSpecialist from '../widget/serviceSpecialist'
  import BasicsInfo from '../widget/basicsInfo'
  import VehicleInfo from '../widget/vehicleInfo'
  import ServiceTel from '../widget/serviceTel'
  import { getAAVOrderInfo, cancelById } from '@/apis/aav.js'
  import { aavOrderPay } from '@/apis/appMethods.js'

  export default {
    name: "index",
    components:{
      OrderStreamer,
      MyProgress,
      ServiceSpecialist,
      BasicsInfo,
      VehicleInfo,
      ServiceTel,
    },
    data() {
      return {
        type:1, // (1:预约成功, 2:正在办理, 3:线上缴费, 4:已完结, 5:取消预约)
        info:{}, // 订单信息
        isLoading: false, // 是否加载中(按钮)
        timer:null, // 支付回调计时器
        hiddenSign: false, // 标记 隐藏标记
      }
    },
    methods:{
      // 取消预约
      cancel() {
        this.$dialog.confirm({
          title: '提示',
          message: '服务专员正火速赶来\n是否确定取消预约',
          cancelButtonColor: '#007aff',
          confirmButtonColor: '#ff3b30',
        }).then((res) => {
          this.isLoading = true;
          cancelById(this.info.id).then(res => {
            getAAVOrderInfo(this.info.id, false).then(res => {
              this.info = res.data;
              this.isLoading = false;
            }).catch(err => {
              this.isLoading = false;
              this.$toast('信息更新失败,请手动刷新');
            })
          }).catch(err => {
            this.isLoading = false;
            this.$toast('取消预约失败');
          })
        }).catch((err) => {/*取消提示框*/})
      },
      // 重新预约
      toReserve() {
        this.$router.push('/AAV/reserve')
      },
      // 订单支付
      payOrder(orderNum) {
        // this.payCallBackListen();
        aavOrderPay(orderNum);
      },
      // 添加付款回调监听(伪, 十分垃圾,但这webview也垃圾,没有html5+,连电话也不能调用)
      payCallBackListen() {
        if (this.timer === null) {
          this.timer = setInterval(() => {
            getAAVOrderInfo(this.$route.query.id,).then(res => {
              console.log('a')
              if (this.info.status === 4) {
                this.info = res.data;
                clearInterval(this.timer);
                this.$toast('支付成功');
              }
            }).catch(e => {
              this.$toast('刷新订单失败');
            });
          }, 3000);
        }
      }
    },
    mounted() {
      window.vm.aavPayCallBack = () => {
        getAAVOrderInfo(this.$route.query.id).then(res => {
          this.info = res.data;
        })
      };
      getAAVOrderInfo(this.$route.query.id).then(res => {
        console.log(res);
        this.info = res.data;
      }).catch(e => {
        this.$toast('获取订单失败');
      });
    },
    beforeDestroy() {
      clearInterval(this.timer);
    }
  }
</script>

<style scoped>
  #order{background: #f5f7fa;}
  .cancel{
    display: flex;
  }
  .cancel>.cancel-button{
    width: 92vw;
    height: 12.533vw;
    margin: 8vw auto 0;
    border-radius: 1.333vw;
    font-size: 4.8vw;
    color: white;
    letter-spacing: 0.24vw;
  }
  #pay{}
  .pay{
    width: 100vw;
    height: 13.067vw;
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0;
  }
  .pay>p{margin-left: 4.267vw}
  .pay-button{
    width: 36vw;
    height: 100%;
    font-size: 4.8vw;
    color: white;
  }

  .button-anim-enter-active,.button-anim-leave-active{transition: all 300ms;}
  .button-anim-enter{transform: translateX(100vw);}
  .button-anim-leave-to{transform: translateX(-100vw);}

</style>
